
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/[programId]",
      function () {
        return require("private-next-pages/programs/[programId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/[programId]"])
      });
    }
  